<template>
  <common-dialog ref="dialog" width="500px" title="绑定新店铺" id-key="id">
    <template slot="form">
      <div style="display: flex;align-items: center;">
        <div>第一步：点击</div>
        <div style="margin-left: 5px;">
          <el-button type="success" @click="onCopy">复制关联店铺绑定链接</el-button>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <div>第二步：将链接发给被绑定的店铺，由该店铺登录后在官方授权页面授权关联</div>
      </div>
      <el-input v-model="mallId" placeholder="请输入店铺编号"></el-input>
    </template>
    <template slot="footer">
      <el-button @click="onBind">绑 定</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import dialogMixin from '@/mixins/dialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [dialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/ali/mall').default,
      link: "https://fuwu.pinduoduo.com/service-market/auth/relate?redirect_uri=http://sdkdapi.chengwithle.com/api/bind/callback&ticket=9af8b1727a9c562a474878512af577d0a53806cd65f25cfee",
      mallId: ''
    };
  },
  methods: {
    onCopy() {
      navigator.clipboard.writeText(this.link).then(() => {
        this.$message.success('复制成功');
      }).catch(err => {
        console.log('复制失败', err);
        this.$message.error('复制失败');
      });
    },
    onBind() {
      this.api.connect(this.mallId).then(res => {
        if (res) {
          var mall_list = [];
          if (res.mallInfos) {
            res.mallInfos.forEach(x => {
              mall_list.push({ logo: x.logo, mallId: x.mallId, mallName: x.mallName, token: x.accessToken })
            })
          }
          localStorage.setItem("mall_list", JSON.stringify(mall_list));
        }
      })
    }
  },
};
</script>
